import styled from 'styled-components';

export const IdleMessageBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  max-width: 1180px;
  height: 100%;
  padding: 0 40px;
`;

export const IdleMessage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;
export const IdleMessageText = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: ${({ theme }) => (theme.colors.grey6)};
  letter-spacing: 0.015em;
  line-height: 1;
`;

export const CountdownMessage = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => (theme.colors.grey6)};
  opacity: 0.725;
  line-height: 1;
  margin-top: 1px;
  margin-bottom: 3px;
`;

export const ExtendTimeButton = styled.div`
  font-size: 18px;
  font-weight: 700;
  line-height: 0;
  margin-bottom: 2px;
  color: ${({ theme }) => (theme.colors.blue6)};
`;
